module.exports = __webpack_public_path__ + "static/gatsbypractice-c811d08fcf83f38c1ad6e41aeb900cb9.png";